import { Routes } from '@angular/router';
import { AuthCallbackComponent } from '@shared/components/auth-callback/auth-callback.component';
import { ConfirmarReservaComponent } from '@shared/components/confirmar-reserva/confirmar-reserva.component';
import { CredencialAgenteCensalComponent } from '@shared/components/credencial-agente-censal/credencial-agente-censal.component';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    title: 'Sistema de Reclutamiento Unico',
    loadChildren: () => import('./pages/pages.routes').then((r) => r.routesPages),
  },
  {
    path: 'auth',
    title: 'Sistema de Reclutamiento Unico',
    loadComponent: () =>
      import('./shared/layouts/auth-layout/auth-layout.component').then(
        (c) => c.AuthLayoutComponent,
      ),
    loadChildren: () => import('./auth/pages/auth.routes').then((r) => r.routesAuth),
  },
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: 'confirmar-reserva/:id', component: ConfirmarReservaComponent },
  {
    path: 'perfil-agente-censal/:documento_identidad',
    title: 'Credencial de Agente Censal',
    component: CredencialAgenteCensalComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotFoundComponent,
    title: '404 - Página no encontrada',
  },
];
